export default function buttonPosition(width, space, deg) {
    const distance = .8
    const radius = width/2

    const rcos = (width - space)/2 + ( radius * Math.cos( -deg * Math.PI / 180 ) * distance )
    const rsin = (width - space)/2 + ( radius * Math.sin( -deg * Math.PI / 180 ) * distance )

    return [rsin.toFixed(0), rcos.toFixed(0)]
}